module.exports = __webpack_public_path__ + "static/bones_of_the_earth-ee0de60fcd139583cb7a18edfbf331e5.png";